export const STATIC_BUTTON_CONFIG = ["history", "process"];